module.exports = __webpack_public_path__ + "img/director-test-icon2.eec16bb9.png";